export const savvyScriptUrl = 'https://bundle.trysavvy.com/bundle.js';
export const savvyApiBaseUrl = 'https://renderer.trysavvy.com';

export const loggedOutHomepageFlowId = '8UC9Wo157ptNV5U4MJ1Q';
